import Link from "next/link";
import styles from "./categoryCard.module.scss";
import { useEffect, useState } from "react";
import BlogCard from "../blogCard/blogCard";
import CustomSpinner from "../spinner/spinner";
import { useWordPressApi } from "@/hooks/useWordPressApi";
import { getHelpCenterCategoryDataById } from "@/lib/wordpressApi";

const CategoryCard = ({
  isArticles,
  title,
  description,
  categorySlug,
  categoryId,
}) => {
  const [productsData, setProductsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const {
    getArticlesCategoriesById,
    getHelpCenterCategoryDataById,
    currentLanguage,
  } = useWordPressApi();

  // Helper function to fetch all pages of data
  const fetchAllPages = async (baseUrl) => {
    let allData = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      try {
        const response = await fetch(`${baseUrl}&per_page=100&page=${page}`);
        const data = await response.json();

        if (data.length === 0) {
          hasMore = false;
        } else {
          allData = [...allData, ...data];
          page++;

          // Check if we got less than 100 items (last page)
          if (data.length < 100) {
            hasMore = false;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        hasMore = false;
      }
    }

    return allData;
  };

  useEffect(() => {
    (async () => {
      if (categoryId > 0) {
        if (isArticles) {
          const data = await getArticlesCategoriesById(
            categoryId,
            currentLanguage
          );

          setProductsData(data);
          setLoading(false);
        } else {
          const data = await getHelpCenterCategoryDataById(
            categoryId,
            currentLanguage
          );
          setProductsData(data);
          setLoading(false);
        }
      }
    })();
  }, [categoryId]);

  return (
    <>
      <div className={`${styles["categoryCardContainer"]}`}>
        <>
          <div className={`${styles["categoryCard"]}`}>
            <Link
              href={`${
                isArticles
                  ? `/en/articles/categories/${categorySlug}`
                  : `/en/help-center/${categorySlug}`
              }
                `}
            >
              <h2>{title}</h2>
            </Link>

            {/* <p>{description}</p> */}
          </div>
          <div className={`${styles["blogs"]}`}>
            {productsData &&
              productsData.map((blog) => (
                <BlogCard
                  key={blog.id}
                  title={blog.title.rendered}
                  featured={blog?.acf.featured_blog}
                  blogUrl={`${
                    isArticles
                      ? `/en/articles/${blog.slug}/`
                      : `/en/help-center/${categorySlug}/${blog.slug}/`
                  }`}
                />
              ))}
          </div>
        </>
      </div>
    </>
  );
};

export default CategoryCard;
